import NotFound from '../components/moduleComponents/NotFound'

const NotFoundPage = () => {
  return <NotFound />
}

export default NotFoundPage
